import { BlujayCredentials } from './blujay-credentials.model';

export class Subcontractor {

  public id: string;
  public name: string;
  public isEu                                 = true;
  public address: string;
  public vatCode: string;
  public loadGroup: string;
  public blujayCredentials: BlujayCredentials = new BlujayCredentials();

  public showBlujayCredentials = false;

  static fromDto(d: any): Subcontractor {
    if (!d) {
      return null;
    }

    const subcontractor = new Subcontractor();

    subcontractor.id                = d.id;
    subcontractor.name              = d.name;
    subcontractor.isEu              = d.eu;
    subcontractor.address           = d.address;
    subcontractor.vatCode           = d.vat_code;
    subcontractor.loadGroup         = d.load_group;
    subcontractor.blujayCredentials = BlujayCredentials.fromDto(d.blujay_credentials);

    return subcontractor;
  }

  static toDto(subcontractor: Subcontractor): any {
    if (!subcontractor) {
      return null;
    }

    return {
      id: subcontractor.id,
      name: subcontractor.name,
      eu: subcontractor.isEu,
      address: subcontractor.address,
      vat_code: subcontractor.vatCode,
      load_group: subcontractor.loadGroup,
      blujay_credentials: subcontractor.blujayCredentials
    };
  }
}
